<mat-form-field floatLabel="always" class="textbox"
  [style]="textArea.inlineStyle ? layoutElemeneUtil.translateStyle(textArea.inlineStyle):''"
  appearance="outline">
  <mat-label class="custom-form-caption-label">{{ textArea.caption }}</mat-label>
  <textarea [(ngModel)]="textArea.content"
    [maxlength]="textArea.maxChars === 0 ? null : textArea.maxChars!"
    [rows]="textArea.rows" [disabled]="layoutElemeneUtil.ReadonlyMode"
  (ngModelChange)="fire($event)" matInput></textarea>

  @if (textArea.maxCharsWarning && textArea.maxChars) {
    <app-character-counter
      [maxChars]="textArea.maxChars"
      [maxCharsWarning]="textArea.maxCharsWarning"
      [charSequenceLength]="textArea!.content!.length"
    [isArdPopnacht]="textArea.isArdPopnacht"></app-character-counter>
  }
  @if (textArea.showKiRefreshButton) {
    <button aria-label="Erneut Laden" matTooltip="Erneut Laden" mat-icon-button [disabled]="layoutElemeneUtil.ReadonlyMode || ((loading$ | async)?.showProgressbar)" style="display: inline-flex" (click)="fireKiEvent($event, false)">
      <mat-icon aria-label="Erneut Laden">replay</mat-icon>
    </button>
    <button aria-label="Erneut Laden Text verkürzen" matTooltip="Erneut Laden Text verkürzen" mat-icon-button [disabled]="layoutElemeneUtil.ReadonlyMode || ((loading$ | async)?.showProgressbar)" style="display: inline-flex" (click)="fireKiEvent($event, true)">
      <mat-icon>replay_10</mat-icon>
    </button>
  }

  @if (textArea.showKiFeedbackButtons) {
    <button aria-label="Guter Text" matTooltip="Guter Text" mat-icon-button
      [disabled]="layoutElemeneUtil.ReadonlyMode" style="display: inline-flex"
      (click)="starteFeedback('positiv')">
      <mat-icon>thumb_up</mat-icon>
    </button>
    <button aria-label="Schlechter Text" matTooltip="Schlechter Text" mat-icon-button
      [disabled]="layoutElemeneUtil.ReadonlyMode" style="display: inline-flex"
      (click)="starteFeedback('negativ')">
      <mat-icon>thumb_down</mat-icon>
    </button>
    @if (textArea.feedback; as feedback) {
      <button
        [attr.aria-label]="'Feedback (' + feedback.typ + ') anzeigen'"
        [matTooltip]="feedback.kommentar ? 'Feedback (' + feedback.typ + ') – Kommentar anzeigen' : 'Feedback: ' + feedback.typ"
        mat-icon-button class="feedback-abgegeben"
        [class.feedback-abgegeben--positiv]="feedback.typ === 'positiv'"
        [class.feedback-abgegeben--negativ]="feedback.typ === 'negativ'"
        style="display: inline-flex"
        (click)="toggleFeedbackAnzeige()">
        <mat-icon>{{ feedback.typ === 'positiv' ? 'thumb_up' : 'thumb_down' }}</mat-icon>
      </button>
    }
  }

</mat-form-field>

@if (feedbackEntwurf; as entwurf) {
  <!-- Kommentar-Eingabe zum gerade gewählten Daumen; Haken übernimmt, X verwirft. -->
  <div class="feedback-entwurf" [class.feedback-entwurf--negativ]="entwurf.typ === 'negativ'"
    role="group" aria-label="Kommentar zum Feedback">
    <mat-icon class="feedback-entwurf__icon">{{ entwurf.typ === 'positiv' ? 'thumb_up' : 'thumb_down' }}</mat-icon>
    <textarea class="feedback-entwurf__text" rows="2" placeholder="Kommentar (optional)"
      aria-label="Kommentar zum Feedback"
      [(ngModel)]="entwurf.kommentar"></textarea>
    <button aria-label="Feedback speichern" matTooltip="Feedback speichern" mat-icon-button (click)="bestaetigeFeedback()">
      <mat-icon>check</mat-icon>
    </button>
    <button aria-label="Abbrechen" matTooltip="Abbrechen" mat-icon-button (click)="verwerfeFeedback()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

@if (feedbackAnzeigen) {
  @if (textArea.feedback; as feedback) {
    <!-- Der zuvor abgegebene Kommentar – erscheint erst auf Klick auf den Daumen oben. -->
    <div class="feedback-anzeige" [class.feedback-anzeige--negativ]="feedback.typ === 'negativ'" role="note">
      <mat-icon>{{ feedback.typ === 'positiv' ? 'thumb_up' : 'thumb_down' }}</mat-icon>
      <span class="feedback-anzeige__text">{{ feedback.kommentar || '(kein Kommentar)' }}</span>
      <button aria-label="Schließen" matTooltip="Schließen" mat-icon-button (click)="feedbackAnzeigen = false">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
}
